<script lang="ts">
  import Main from './components/Main.svelte';
  import Text from './components/Text.svelte';
</script>

<Main>
  <Text size="large" bold>Kein Zugriff</Text>
  <Text>Bitte wenden Sie sich an Ihre:n Administrator:in.</Text>
</Main>
